import React from 'react';
import './errorBlock.css';
import { Link } from 'react-router-dom';

const ErrorBlock = () => (
  <div className='error-block'>
    <h1 className='error-block-title'>Page not found. <br /> Please check, if page-URL is correct.</h1>
    <Link to='/' className='btn btn-primary error-redirect-link'>Go back to main page</Link>
  </div>
)

export default ErrorBlock